import { RMAXLogger } from '../services/LoggerService/RMAXLogger';
let isHandlerRegistered = false;

/**
 * Global handler for unhandled promise rejections
 * Specifically handles cancelled/stale requests from deduplication system
 * Prevents console errors for cancelled requests and logs to Datadog
 */
const registerUnhandledRejectionHandler = () => {
  if (isHandlerRegistered) {
    return;
  }
  if (!('window' in globalThis)) {
    // Not in browser environment (e.g., SSR)
    return;
  }
  globalThis.window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    if (reason === 'Stale request. Cancelled') {
      // Prevent default console error logging
      event.preventDefault();
      return;
    }
    RMAXLogger.error('Unhandled promise rejection', {
      type: event?.type || 'unhandled_promise_rejection',
      reason: reason?.toString() || 'Unknown reason',
      timestamp: event?.timestamp || new Date().toISOString()
    });
  });
  isHandlerRegistered = true;
};

export default registerUnhandledRejectionHandler;
